export default "/assets/images/mila-box.webp?fb19ea76d127dbcb54809d8551ca4407";